document.addEventListener('DOMContentLoaded', function() {
  var selectors = {
    readMoreTop: '[data-read-more-top]',
    readMoreBottom: '[data-read-more-bottom]',
    descriptionText: '[data-description-text]',
    readMoreButton: '[data-read-more-button]',
    readLessButton: '[data-read-less-button]'
  }
  var elements = _getElements();
  if (elements.top && elements.bottom) {
    elements.top.readMoreButton.style.display = 'block';
    elements.top.readMoreButton.addEventListener('click', readMoreTopButtonOnClick);
  }
  if (elements.bottom) {
    detectTextClamped();
    elements.bottom.readMoreButton.addEventListener('click', readMoreButtonOnClick);
    elements.bottom.readLessButton.addEventListener('click', readLessButtonOnClick);
    var prevWidth = elements.bottom.container.offsetWidth;
    new ResizeObserver(e => {
      var width = e[0].target.offsetWidth;
      if (width != prevWidth) {
        detectTextClamped();
        prevWidth = width;
      }
    }).observe(elements.bottom.container);
  }

  function _getElements() {
    var els = {};
    var containerTop = document.querySelector(selectors.readMoreTop);
    if (containerTop) {
      var containerTopItem = {
        container: containerTop,
        readMoreButton: containerTop.querySelector(selectors.readMoreButton)
      }
      els.top = containerTopItem;
    }
    var containerBottom = document.querySelector(selectors.readMoreBottom);
    if (containerBottom) {
      var containerBottomItem = {
        container: containerBottom,
        descriptionText: containerBottom.querySelector(selectors.descriptionText),
        readMoreButton: containerBottom.querySelector(selectors.readMoreButton),
        readLessButton: containerBottom.querySelector(selectors.readLessButton)
      }
      els.bottom = containerBottomItem;
    }
    return els;
  }

  function readMoreTopButtonOnClick() {
    elements.bottom.container.scrollIntoView(true);
  }

  function readMoreButtonOnClick(el) {
    el.currentTarget.parentNode.querySelector(selectors.descriptionText).classList.add('description-expand');
    el.currentTarget.style.display = 'none';
    el.currentTarget.parentNode.querySelector(selectors.readLessButton).style.display = 'block';
  }

  function readLessButtonOnClick(el) {
    el.currentTarget.parentNode.querySelector(selectors.descriptionText).classList.remove('description-expand');
    el.currentTarget.style.display = 'none';
    el.currentTarget.parentNode.querySelector(selectors.readMoreButton).style.display = 'block';
  }
});

// Logic to the Read More/Read Less button on the bottom description
var description = document.querySelector('.collection-hero__description_bottom');
var readMoreBtn = document.querySelector('.collection-hero__description-read-more');
var readLessBtn = document.querySelector('.collection-hero__description-read-less');

var originalHTML = description.innerHTML;
var originalText = description.textContent.trim();
var words = originalText.split(/\s+/);
var limitedWords = words.slice(0, 50).join(' ');
var limitedText = originalHTML.slice(0, 280);
var isExpanded = false;

if (words.length > 50) {
  description.innerHTML = limitedText + '<span class="ellipsis">...</span>';
  readMoreBtn.style.display = 'block';
}

readMoreBtn.addEventListener('click', function() {
  if (!isExpanded) {
    description.innerHTML = originalHTML;
    readMoreBtn.style.display = 'none';
    readLessBtn.style.display = 'block';
    isExpanded = true;
  }
});

readLessBtn.addEventListener('click', function() {
  if (isExpanded) {
    description.innerHTML = limitedText + '<span class="ellipsis">...</span>';
    readMoreBtn.style.display = 'block';
    readLessBtn.style.display = 'none';
    isExpanded = false;
  }
});
